import { Component, Input, OnInit } from '@angular/core';
import {
  IconDefinition as SolidIconDefinition,
  faAngleLeft,
  faAngleRight,
  faBell as solidBell,
  faArrowRight,
  faArrowDown,
  faBan,
  faBars,
  faBed,
  faCheckCircle,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronDown,
  faChevronRight,
  faExternalLinkAlt,
  faEyeSlash,
  faEye,
  faHistory,
  faInfoCircle,
  faLock,
  faMap,
  faMapMarker,
  faMinusCircle,
  faPaperclip,
  faPhone,
  faPhoneAlt,
  faPlusCircle,
  faPrint,
  faSearch,
  faShareSquare,
  faTag,
  faTimes,
  faTimesCircle,
  faTrash,
  faUpload,
  faWindowClose,
  faMoneyBillWave,
  faListUl,
  faExclamationTriangle,
  faUndo,
  faCode,
  faCodeBranch,
  faArrowCircleRight,
  faRunning,
  faBorderAll,
  faCopyright,
  faStar as solidStar,
  faSign,
  faPlus,
  faLink,
  faUnlockAlt,
  faCalendarDay,
} from '@fortawesome/free-solid-svg-icons';

import {
  IconDefinition as RegularIconDefinition,
  faEnvelopeOpen,
   faEnvelope,
   faEdit,
   faBell,
   faComment,
   faCalendar,
   faFilePdf,
   faFile,
   faFileImage,
   faFileVideo,
   faTrashAlt,
   faMinusSquare,
   faPlusSquare,
   faCalendarCheck,
   faComments,
   faThumbsUp,
   faClock,
   faClone,
   faUser,
   faStar
} from '@fortawesome/free-regular-svg-icons';

import {
  IconDefinition as BrandIconDefinition,
  faFacebookSquare,
  faLinkedin,
  faTwitterSquare,
  faHubspot,
} from '@fortawesome/free-brands-svg-icons';
import { RotateProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

type StringNameOfIcon = string;
type IconDefinition = BrandIconDefinition | RegularIconDefinition | SolidIconDefinition

@Component({
  selector: 'fa',
  template: `
    <fa-icon
      [icon]="iconReference"
      [size]="size"
      [rotate]="rotate"
    >
    </fa-icon>
  `,
})
export class IconComponent implements OnInit {
  @Input() name: StringNameOfIcon;
  @Input() size: SizeProp = null;
  @Input() rotate: RotateProp = null;
  // https://github.com/FortAwesome/angular-fontawesome/blob/master/docs/usage/features.md

  constructor() { }

  public iconReference: IconDefinition;

  private stringNameToIconReferenceMap: { [key: string]: IconDefinition } = {
    'times-circle': faTimesCircle,
    'search': faSearch,
    'angle-left': faAngleLeft,
    'angle-right': faAngleRight,
    'window-close': faWindowClose,
    'print': faPrint,
    'bars': faBars,
    'copyright': faCopyright,
    'pencil-square-o': faEdit,
    'chevron-right': faChevronRight,
    'bell-o': faBell,
    'map-marker': faMapMarker,
    'lock': faLock,
    'un-lock': faUnlockAlt,
    'calendar': faCalendar,
    'comments': faComments,
    'paperclip': faPaperclip,
    'comment-o': faComment,
    'history': faHistory,
    'closed-envelope': faEnvelope,
    'open-envelope': faEnvelopeOpen,
    'file-pdf-o': faFilePdf,
    'share-square': faShareSquare,
    'file-o': faFile,
    'file-image-o': faFileImage,
    'file-video-o': faFileVideo,
    'facebook-square': faFacebookSquare,
    'twitter-square': faTwitterSquare,
    'linkedin-square': faLinkedin,
    'link': faLink,
    'trash-o': faTrashAlt,
    'minus-square-o': faMinusSquare,
    'plus-square-o': faPlusSquare,
    'plus': faPlus,
    'times': faTimes,
    'eye-slash': faEyeSlash,
    'hubspot': faHubspot,
    'eye': faEye,
    'code': faCode,
    'trash': faTrash,
    'clock': faClock,
    'external-link': faExternalLinkAlt,
    'minus-circle':faMinusCircle,
    'check-circle':faCheckCircle,
    'info-circle':faInfoCircle,
    'phone': faPhone,
    'phone-alt': faPhoneAlt,
    'chevron-circle-left':faChevronCircleLeft,
    'chevron-circle-right':faChevronCircleRight,
    'circle-arrow-right':faArrowCircleRight,
    'map': faMap,
    'bed':faBed,
    'tag': faTag,
    'chevron-down': faChevronDown,
    'upload': faUpload,
    'ban': faBan,
    'running': faRunning,
    'thumbs-up': faThumbsUp,
    'plus-circle': faPlusCircle,
    'arrow-right': faArrowRight,
    'arrow-down': faArrowDown,
    'solid-bell': solidBell,
    'money-bill-wave': faMoneyBillWave,
    'calendar-check': faCalendarCheck,
    'calendar-day': faCalendarDay,
    'list-ul': faListUl,
    'undo': faUndo,
    'exclaimation-triangle': faExclamationTriangle,
    'code-branch': faCodeBranch,
    'user': faUser,
    'grid': faBorderAll,
    'copy': faClone,
    'solid-star': solidStar,
    'star': faStar,
    'sign': faSign
  };

  private possibleSizes = ['xs','sm','lg','2x','3x','4x','5x','6x','7x','8x','9x','10x']

  ngOnInit(): void {
    this.setName();

    // no size modifier provided
    if(!this.size) return;
    if(!this.possibleSizes.includes(this.size)){
      // invalid size modifier provided
      throw new Error(`Font Awesome does not accept '${this.size},' as a size modifier. invalid size passed to <fa></fa>`);
    }
  }

  ngOnChanges() {
    this.setName();
  }

  setName() {
    if (!this.stringNameToIconReferenceMap[this.name]) {
      throw new Error(`The string name, '${this.name},' of the icon provided to <fa></fa> does not have a matching import. make sure the correct icon is imported and mapped to in IconComponent.ts`)
    }

    this.iconReference = this.stringNameToIconReferenceMap[this.name]; // not reactive, ad ngOnChanges if necessary
  }

}
